import { createTheme } from "@mui/material/styles";
import baseTheme from "./baseTheme";

// Partner Live Theme - light base with strong live-trading accents
const partnerLiveTheme = createTheme(baseTheme, {
  palette: {
    mode: "light",
    primary: { main: "#16a34a" }, // live green
    secondary: { main: "#f97316" }, // warm accent
    background: { default: "#f9fafb", paper: "#ffffff" },
    text: {
      primary: "#111827",
      secondary: "#6b7280",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Segoe UI", system-ui, -apple-system, sans-serif',
    h3: { fontWeight: 700, letterSpacing: 0.4 },
    h5: { fontWeight: 600, letterSpacing: 0.3 },
    h6: { fontWeight: 600, letterSpacing: 0.2 },
    body2: { color: "#4b5563" },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          boxShadow:
            "0 18px 45px rgba(15, 23, 42, 0.20), 0 1px 0 rgba(255, 255, 255, 0.7)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          textTransform: "none",
          fontWeight: 600,
          paddingInline: 20,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
  },
});

export default partnerLiveTheme;

